import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const restUrl = authorizationServicesPath + '/customers/organizations'

export default class CustomerOrganizationService {

    static async getAll() {
        return axios.get(restUrl + "/favorite");
    }

    static async getFullForCustomersOffersByName(name) {
        return axios.get(restUrl + "/full-for-customers-offers-by-name?name=" + name);
    }

    static async deleteInFavorite(organizationName) {
        return axios.patch(restUrl + "/delete-in-favorite" + "?organizationName=" + organizationName, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}